import React, { useRef, useState } from "react";
import CardSection from "../../../components/ui/card/CardSection";
import { AppIcons } from "../../../data/appIcons";
import SidebarModel from "../../../components/ui/sidebarModel/SidebarModel";
import MainCategoryList from "../../../features/mainCategoryList/MainCategoryList";
import { hasFunctionalPermission } from "../../../utils/authorizeNavigation/authorizeNavigation";
import { securityKey } from "../../../data/SecurityKey";
import "./MainSkill.scss";
import { MainSkillCategoryDataFields } from "../../../features/mainCategoryList/MainCategoryList.Data";
import useDebounce from "../../../app/customHooks/useDebounce";
import { onResetForm } from "../../../utils/FormFields/ResetForm/handleResetForm";
import AddMainSkillCategory from "../../../features/mainCategoryList/AddMainSkillCategory";
import { useEffect } from "react";
const MainCategory = () => {

  const [isModelOpen, setModelOpen] = useState(false);
   const molGridList = useRef();
   const [formData, setFormData] = useState(MainSkillCategoryDataFields.initialState);
   const [isEdit, setIsEdit] = useState(false);
   const [hasButtonPermission,setHasButtonPermission] = useState(false);
   const [search, setSearch] = useState("");
   const debouncedSearch = useDebounce(search, 300);
   const hasAddPermission = hasFunctionalPermission(securityKey.ADDMAINSKILL);

   useEffect(()=>{
    if (hasAddPermission?.hasAccess){
      setHasButtonPermission(true);
    }
    else{
      setHasButtonPermission(false);
    }
   },[hasAddPermission])
    //**Handle Change */
  const handleChange = (event) => {
    const value = event.target.value;
    setSearch(value.trim());
  };

  const handleAdd = () => {
    setIsEdit(false);
    resetForm();
    setModelOpen(true);
  };

  const handleEdit = (data) => {
      resetForm();
      setFormData(data);
      setIsEdit(true);
      setModelOpen(true);
  };

  //** Reset Data */
  const resetForm = () => {
      let form = { ...MainSkillCategoryDataFields };
      onResetForm(form, setFormData, null);
  };

  //** Close model */
  const onSidebarClose = () => {
          setModelOpen(false);
      resetForm();
  };

  //** Success */
  const onSuccess = () => {
      if (molGridList.current && molGridList.current.refreshGrid) {
          molGridList.current.refreshGrid();
      }
  };
  
  return (
    <div className="margin-b-0">
      <CardSection
        cardTitle="Main Skill"
        buttonText="Add"
        buttonClassName="btn theme-btn"
        searchInput={true}
        searchInputName="Search By Skill Category & Main Skill "
        handleChange={handleChange}
        titleButtonClick={handleAdd}
        rightButton={true}
        textWithIcon={false}
        hasButtonPermission={hasButtonPermission}
        iconImg={AppIcons.addIcon}
      >
        <div className="mainCategory-table">
          <MainCategoryList 
           onEdit={handleEdit}
           search={debouncedSearch}
           ref={molGridList}
            />
        </div>
      </CardSection>

      <SidebarModel
        modalTitle={`${isEdit ? "Update" : "Add"} Main Skill  `}
        modalSize="w-40"
        onClose={onSidebarClose}
        isOpen={isModelOpen}
      >
        <div className="sub-skill-detail">
          <AddMainSkillCategory
            onClose={onSidebarClose}
            isEdit={isEdit}
            initData={formData}
            onSuccess={onSuccess}
            onReset={resetForm}
            isModelOpen={isModelOpen}
          />
        </div>
      </SidebarModel>
    </div>
  );
};

export default MainCategory;
